import { render, staticRenderFns } from "./detailNew.vue?vue&type=template&id=6168b229&"
import script from "./detailNew.vue?vue&type=script&lang=js&"
export * from "./detailNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports